import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { AudioRecordingProvider } from '../context/AudioRecordingContext';
import { ApiReloadProvider } from '../context/apiRelaod';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Wrapper from '../components/layouts/Wrapper/Wrapper';
import AsideRouter from '../components/router/AsideRouter';
import ContentRouter from '../components/router/ContentRouter';
import FooterRouter from '../components/router/FooterRouter';
import HeaderRouter from '../components/router/HeaderRouter';
import useDarkMode from '../hooks/useDarkMode';
import useDir from '../hooks/useDir';
import useFontSize from '../hooks/useFontSize';
import colors from '../tailwindcss/colors.tailwind';
import getOS from '../utils/getOS.util';
import useAsideStatus from '../hooks/useAsideStatus';
import { ResourceUsageProvider } from '../context/ResourceUsageContext';
import { useEffect } from 'react';
import useDeviceScreen from '../hooks/useDeviceScreen';

const App = () => {
	getOS();

	const { isDarkTheme } = useDarkMode();
	const { asideStatus, setAsideStatus } = useAsideStatus();
	const { width } = useDeviceScreen();

	const { fontSize } = useFontSize();
	dayjs.extend(localizedFormat);

	const { isRTL } = useDir();

	// Prevent background scroll when mobile sidebar is open
	useEffect(() => {
		const isMobile = (width ?? 0) < 768; // Tailwind md breakpoint
		if (isMobile && asideStatus) {
			document.body.classList.add('overflow-hidden');
		} else {
			document.body.classList.remove('overflow-hidden');
		}
		return () => {
			document.body.classList.remove('overflow-hidden');
		};
	}, [asideStatus, width]);

	return (
		<ApiReloadProvider>
			<AudioRecordingProvider>
				<ResourceUsageProvider>
					<style>{`:root {font-size: ${fontSize}px;
				--toastify-toast-bd-radius: 0.75rem;
				--toastify-color-dark:  ${colors.zinc['800']};
				--toastify-color-info: ${colors.blue['500']};
				--toastify-color-success: ${colors.emerald['500']};
			--toastify-color-warning: ${colors.amber['500']};
			--toastify-color-error: ${colors.red['500']};
			--toastify-color-progress-light: linear-gradient(
				to right,
    			${colors.blue['500']},
    			${colors.emerald['500']},
    			${colors.amber['500']},
				${colors.red['500']});`}</style>
					<div data-component-name='App' className='flex grow flex-col'>
						{/* Overlay for mobile - only visible when sidebar is open */}
						{asideStatus && (
							<div
								className='fixed inset-0 z-30 bg-black/50 md:hidden'
								aria-hidden='true'
								role='presentation'
								onClick={() => setAsideStatus(false)}
							/>
						)}
						<AsideRouter />
						<Wrapper>
							<HeaderRouter />
							<ContentRouter />
							<FooterRouter />
						</Wrapper>
					</div>
					<ToastContainer theme={'light'} hideProgressBar rtl={isRTL} />
				</ResourceUsageProvider>
			</AudioRecordingProvider>
		</ApiReloadProvider>
	);
};

export default App;
